var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AddressModel } from './address';
import { BaseEntity, MemoizeGetters, Transform, toEntity } from './base';
let UserAddressModel = class UserAddressModel extends BaseEntity {
};
__decorate([
    Transform(toEntity(AddressModel)),
    __metadata("design:type", AddressModel)
], UserAddressModel.prototype, "address", void 0);
UserAddressModel = __decorate([
    MemoizeGetters
], UserAddressModel);
export { UserAddressModel };
//# sourceMappingURL=user-address.js.map


// WEBPACK FOOTER //
// ./src/models/user-address.ts.pre-build-optimizer.js